import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GalleryComponent } from 'src/app/view/gallery/gallery.component';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';
import { GalleryItemComponent } from 'src/app/view/gallery/gallery-item/gallery-item.component';



@NgModule({
  declarations: [
    GalleryComponent,
    GalleryItemComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild([
      {path:'',component:GalleryComponent,children:[
        {path:':id',component:GalleryItemComponent}
      ]}
    ])
  ]
})
export class GalleryModule { }
